/**
 * MSAL instance singleton — avoids importing index.js (which pulls in the entire app tree).
 * Set once in index.js, used by authHelpers.js and axios interceptor.
 */
let _instance = null;

export function setMsalInstance(instance) {
  _instance = instance;
}

export function getMsalInstance() {
  return _instance;
}
